// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem"};